import { Icon } from '@components';
import bloqueios from './Bloqueios';
import configuracoes from './Configuracoes';
import comandos from './Comandos';
import conexoes from './Conexoes';
import duplicacao from './Duplicacao';
import folgas from './Folgas';
import fontesDados from './FontesDados';
import headers from './Headers';
import logs from './Logs';
import notificacao from './Notificacao';
import tarefas from './Tarefas';
import templates from './Templates';
import versoes from './Versoes';

export default [
  {
    path: '/conectores',
    icon: Icon.ApiOutlined,
    text: 'Conectores',
    match: /\/conectores+$/,
    exact: true,
    sider: true,
  },
  ...bloqueios,
  ...comandos,
  ...conexoes,
  ...configuracoes,
  ...duplicacao,
  ...folgas,
  ...fontesDados,
  ...headers,
  ...logs,
  ...notificacao,
  ...tarefas,
  ...templates,
  ...versoes,
];
